import React from 'react'
import { CanvasTexture, Vector3 } from 'three'

interface IndicatorProps {
  position: Vector3 | [number, number, number]
  isVisible: boolean
}

const createExclamationTexture = () => {
  const canvas = document.createElement('canvas')
  canvas.width = 64
  canvas.height = 64
  const context = canvas.getContext('2d')
  if (!context) return null
  context.clearRect(0, 0, canvas.width, canvas.height)

  context.fillStyle = '#AD7F35'
  context.font = 'bold 48px Arial'
  context.textAlign = 'center'
  context.textBaseline = 'middle'
  context.fillText('!', canvas.width / 2, canvas.height / 2)

  return new CanvasTexture(canvas)
}

const exclamationTexture = createExclamationTexture()

const Indicator: React.FC<IndicatorProps> = ({ position, isVisible }) => {
  const texture = exclamationTexture
  if (!isVisible || !texture) {
    return null
  }

  const indicatorPosition: [number, number, number] = Array.isArray(position)
    ? [position[0], position[1] + 0.3, position[2]]
    : [position.x, position.y + 0.3, position.z]

  return (
    <sprite position={indicatorPosition} scale={[0.4, 0.4, 1]}>
      <spriteMaterial
        map={texture}
        depthTest={false}
        fog={false}
        transparent={true}
      />
    </sprite>
  )
}

export default Indicator
